import { render, staticRenderFns } from "./ViewDashboard.vue?vue&type=template&id=251ae95d&scoped=true&"
import script from "./ViewDashboard.vue?vue&type=script&lang=js&"
export * from "./ViewDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251ae95d",
  null
  
)

export default component.exports